/*
 *
 * Do not edit directly
 * Generated on Wed, 29 Oct 2025 07:39:06 GMT
 *
 */

import PaletteIconChevronRight from '@telus-uds/palette-koodo/build/rn/icons/ChevronRight'
const theme = {
  appearances: { inverse: { type: 'variant', values: [ true ] } },
  rules: [
    {
      if: { inverse: true },
      tokens: {
        color: '#ffffff',
        currentColor: '#ffffff',
        iconColor: '#c9c8c8'
      }
    }
  ],
  tokens: {
    color: '#000000',
    currentColor: '#000000',
    fontName: 'StagSans',
    fontSize: 14,
    fontWeight: '600',
    icon: PaletteIconChevronRight,
    iconColor: '#000000',
    iconContainerSize: 20,
    iconPadding: 4,
    iconSize: 16,
    lineHeight: 1.42857142857,
    listItemPadding: 0
  }
}
export default theme
